import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Film, Home } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const NotFound: React.FC = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#030811] flex flex-col items-center justify-center text-center p-6 relative overflow-hidden">
      <Helmet>
        <title>{language === 'TR' ? "404 - Sayfa Bulunamadı | WE24 Agency" : "404 - Page Not Found | WE24 Agency"}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Ambient background blur */}
      <div className="absolute w-[500px] h-[300px] bg-[#ff7a63]/10 blur-[140px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-lg mx-auto flex flex-col items-center">
        <div className="w-16 h-16 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center text-[#ff7a63] mb-6 shadow-2xl">
          <Film className="w-8 h-8" />
        </div>

        <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#ff7a63] mb-2 block">
          404 ERROR
        </span>

        <h1 className="text-4xl sm:text-5xl font-display font-extrabold text-white tracking-tight mb-3">
          {language === 'TR' ? "Bu kareyi bulamadık." : "Page Not Found"}
        </h1>

        <p className="text-sm text-zinc-400 max-w-md mb-8 leading-relaxed">
          {language === 'TR'
            ? "Aradığınız sayfa kaldırılmış, bağlantı adresi değiştirilmiş ya da geçici olarak kullanım dışı kalmış olabilir."
            : "The page you are looking for might have been removed, renamed, or is temporarily unavailable."}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 w-full sm:w-auto">
          <Link
            to={language === 'TR' ? "/" : "/en"}
            className="px-7 py-3 bg-white text-zinc-950 hover:bg-zinc-200 text-xs font-bold uppercase tracking-wider rounded-full transition-all inline-flex items-center gap-2 shadow-xl"
          >
            <Home className="w-3.5 h-3.5" />
            <span>{language === 'TR' ? "Ana Sayfaya Dön" : "Back to Home"}</span>
          </Link>
          <Link
            to={language === 'TR' ? "/projeler" : "/en/projects"}
            className="px-7 py-3 bg-white/[0.06] hover:bg-white/[0.12] border border-white/15 text-white text-xs font-bold uppercase tracking-wider rounded-full transition-all inline-flex items-center gap-2"
          >
            <span>{language === 'TR' ? "Projelerimizi İnceleyin" : "Explore Projects"}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
